import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useConfig } from "../../_util/config-context";
import { ImagePreview } from "../../imagepreview";
export var Image = React.forwardRef(function Image(_a, ref) {
    var filename = _a.filename, image = _a.image, percent = _a.percent, description = _a.description, button = _a.button, className = _a.className, props = __rest(_a, ["filename", "image", "percent", "description", "button", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-form-upload-img", className) }, props),
        React.createElement("div", { className: classPrefix + "-form-upload__inner" },
            React.createElement("div", { className: classPrefix + "-form-upload__box" },
                image && (React.createElement("div", { className: classPrefix + "-form-upload__thumb" },
                    React.createElement(ImagePreview, { className: classPrefix + "-form-upload__preview", previewSrc: image, src: image }))),
                React.createElement("div", { className: classPrefix + "-form-upload__info" },
                    filename && (React.createElement("div", { className: classPrefix + "-form-upload__file" },
                        React.createElement("span", { className: classPrefix + "-text" }, filename),
                        (percent || percent === 0) && (React.createElement("span", { className: classPrefix + "-form__help-text--inline" },
                            Math.floor(percent),
                            "%")))),
                    React.createElement("div", { className: classPrefix + "-form-upload__intro " + classPrefix + "-text-weak" }, description),
                    React.createElement("div", { className: classPrefix + "-form-upload__btn" }, button))))));
});
Image.displayName = "UploadImage";
//# sourceMappingURL=Image.js.map